module.exports = __webpack_public_path__ + "img/powerled_es.596519c0.jpg";